<script setup lang="ts">
import DepartmentPanel from "@/components/people/DepartmentPanel.vue"
import PeoplePanel from "@/components/people/PeoplePanel.vue"
import { defineProps, onMounted, reactive, withDefaults } from "vue"

export interface Props {
  department: any
  level: number
  collapsable: boolean
  open: boolean
}

const props = withDefaults(defineProps<Props>(), {
  department: undefined,
  level: 1,
  collapsable: true,
  open: false,
})
const state = reactive<{
  collapseClassName: string | undefined
  subDepartmentData: Array<any> | undefined
  noData: boolean
}>({
  collapseClassName: undefined,
  subDepartmentData: undefined,
  noData: false,
})

onMounted(async () => {
  if (props.department === undefined) {
    return
  }
  state.collapseClassName = `collapse_${props.level}_${props.department.tid}`
  const subDepartmentData = await fetch(`/api/taxonomy/departments?parent_tid=${props.department.tid}`).then((res) =>
    res.json()
  )
  state.subDepartmentData = subDepartmentData
})

function handlePeoplePanelDataLoaded(peopleData: Array<any>): void {
  console.log(peopleData)
  // state.noData = state.subDepartmentData !== undefined &&
  //   state.subDepartmentData.length === 0 &&
  //   peopleData.length === 0
  // if (state.noData) {
  //   console.log(props.department, state.subDepartmentData, peopleData)
  // }
}
</script>

<template>
  <div v-if="props.department !== undefined" class="department-panel accordion accordion-wrapper">
    <div class="card accordion-item">
      <div class="card-header">
        <button
          v-if="collapsable === true"
          :class="[open ? '' : 'collapsed']"
          data-bs-toggle="collapse"
          :data-bs-target="'.' + state.collapseClassName"
          aria-expanded="true"
          :aria-controls="state.collapseClassName"
        >
          {{ props.department.name }}
        </button>
        <span v-if="collapsable === false" class="none-collapse bg-light">{{ props.department.name }}</span>
      </div>
      <div
        :class="[
          'accordion-collapse',
          'collapse',
          state.collapseClassName,
          collapsable ? (open ? 'show' : '') : 'd-block',
        ]"
      >
        <div v-if="state.subDepartmentData !== undefined" class="accordion-body">
          <PeoplePanel :department="props.department" @dataLoaded="handlePeoplePanelDataLoaded($event)"></PeoplePanel>
          <DepartmentPanel
            v-for="(item, index) in state.subDepartmentData"
            :key="index"
            :department="item"
            :level="level + 1"
          ></DepartmentPanel>
        </div>
      </div>
    </div>
  </div>
</template>
